import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { IUpdateOferta, IUpdateOfertaResponse } from '../../interfaces/response/IUpdateOfertaResponse';

@Injectable({
    providedIn: 'root'
})
export class OfertasService {

    baseUrl = `${environment.baseUrl}`;
    apiUrl = `${environment.ApiPricing}`;
    url: string;

    constructor(private http: HttpClient) {
        this.url = this.baseUrl + this.apiUrl;
    }

    seleccionarOferta(idOferta: number, activada: boolean, seleccionada: boolean = true, proxy: boolean = false): Observable<IUpdateOferta> {
        let url = `${this.url}/SelectOffer/${idOferta}`
        if (proxy){     
            const apiUrl = `${environment.proxy.root}/${environment.proxy.api}/api-pricing/api`     
            url = `${apiUrl}/SelectOffer/${idOferta}`;
        } 

      return this.http.post<IUpdateOfertaResponse>(url, { activada, seleccionada }).pipe(
            map(resp => resp.data)
        ); 
    }

    ofertasAdicionales(idPoliza: number): Observable<any> {
      return this.http.get<any>(`${this.url}/GetAdditionalsOffersbyPolicy/${idPoliza}`);
    }
}
